import { MessageType } from '../enums';
/**
 * Handles a SYN handshake message.
 */
export default (log, methods, childOrigin, originForSending) => {
    return (event) => {
        if (event.origin !== childOrigin) {
            log(`Parent: Handshake - Received SYN message from origin ${event.origin} which did not match expected origin ${childOrigin}`);
            return;
        }
        log('Parent: Handshake - Received SYN, responding with SYN-ACK');
        const synAckMessage = {
            penpal: MessageType.SynAck,
            methodNames: Object.keys(methods)
        };
        event.source.postMessage(synAckMessage, originForSending);
    };
};
